import {
  REQUEST_INFO,
  REQUEST_INFO_SUCCESS,
  REQUEST_INFO_ERROR,
  REQUEST_PAGE_SET,
  REQUEST_EDIT_MODAL_SET,
  REQUEST_EDIT_CHANGE,
  REQUEST_UPDATE,
  REQUEST_UPDATE_SUCCESS,
  REQUEST_UPDATE_ERROR
} from '../actions';

const INIT_STATE = {
  loading: true,
  list: {
    data:[],
    page:{
      current: 1,
      rows: 500
    }
  },
  info: {
    data: {
      idrequest: 0
    },
    loading: true,
  },
  edit: {
    loading: true,
    data: {
      new:[],
      old:[]
    },
    modal: false,
    update: {
      loading: false,
      response: '',
      message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_INFO:
      return {
        ...state,
        info: {
          ...state.info,
          loading: true,
        }
      }
    case REQUEST_INFO_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          loading: false,
          data: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience }
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience },
            old: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience }
          }
        }
      }
    case REQUEST_INFO_ERROR:
      return {
        ...state,
        info: {
          ...state.info,
          loading: false
        }
      }
    case REQUEST_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        }
      }
    case REQUEST_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case REQUEST_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case REQUEST_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case REQUEST_UPDATE_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          loading: false,
          data: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience }
        },
        edit: {
          ...state.edit,
          modal:false,
          data: {
            ...state.edit.data,
            new: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience },
            old: {...action.payload.request, request_answer: action.payload.request_answer, request_geo_country: action.payload.request_geo_country, request_experience: action.payload.request_experience }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload.message
          }
        }
      }
    case REQUEST_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload.message
          }
        }
      }
    default:
      return { ...state };
  }
};